import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { THEME_MODE } from "src/config/constants";
import { useParticularPoolsSelector } from "src/context/poolsContext";
import { numberWithCommas, toFixed } from "src/services/utils";
import TopItem from "./TopItem";

const useStyle = makeStyles((theme) => ({
  supplyPaper: {
    background: theme.palette.background.blue,
    marginTop: "0.5rem",
  },
  borrowPaper: {
    background: theme.palette.background.violet,
    marginTop: "0.5rem",
  },
  supplyColor: {
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#000812" : "#06326A",
  },
  borrowColor: {
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#000812" : "#584786",
  },
  supplyColorPrimary: {
    backgroundColor: "#408CEC",
  },
  borrowColorPrimary: {
    backgroundColor: "#B39DDB",
  },
}));

export default function TopSupplyBorrow() {
  const cls = useStyle();
  const { pool } = useParams();
  const { token: tokenConfig } = useParticularPoolsSelector(pool);

  const { totalSupply, totalBorrow, top3Supply, top3Borrow, isLoading } = useMemo(() => {
    if (tokenConfig) {
      let totalSupply = 0;
      let totalBorrow = 0;
      const _tokenConfig = Object.values(tokenConfig);
      for (let _token of _tokenConfig) {
        totalSupply += _token.totalSupply;
        totalBorrow += _token.totalBorrow;
      }
      const top3Supply = _tokenConfig
        .sort((item1, item2) => item2.totalSupply - item1.totalSupply)
        .slice(0, 3)
        .map((token) => {
          return {
            symbol: token.symbol,
            value: token.totalSupply,
            percent: token.totalSupply / totalSupply,
          };
        });
      const top3Borrow = _tokenConfig
        .sort((item1, item2) => item2.totalBorrow - item1.totalBorrow)
        .slice(0, 3)
        .map((token) => {
          return {
            symbol: token.symbol,
            value: token.totalBorrow,
            percent: token.totalBorrow / totalBorrow,
          };
        });
      return { totalSupply, totalBorrow, top3Supply, top3Borrow, isLoading: false };
    }
    return { totalSupply: 0, totalBorrow: 0, top3Supply: [], top3Borrow: [], isLoading: true };
  }, [tokenConfig]);

  return (
    <Grid container spacing={2}>
      <Grid item md={6} sm={12} xs={12}>
        <Box>
          <Typography variant="h5">Total Supply</Typography>
          <Typography variant="h4" color="primary">
            {isLoading ? <Skeleton /> : `$${numberWithCommas(toFixed(totalSupply, 2))}`}
          </Typography>
        </Box>
        <TopItem
          title="Top Supply Token"
          topData={top3Supply}
          classes={{ root: cls.supplyPaper, bar: cls.supplyColorPrimary, color: cls.supplyColor }}
        />
      </Grid>
      <Grid item md={6} sm={12} xs={12}>
        <Box>
          <Typography variant="h5">Total Borrow</Typography>
          <Typography variant="h4" color="secondary">
            {isLoading ? <Skeleton /> : `$${numberWithCommas(toFixed(totalBorrow, 2))}`}
          </Typography>
        </Box>
        <TopItem
          title="Top Borrow Token"
          topData={top3Borrow}
          classes={{ root: cls.borrowPaper, bar: cls.borrowColorPrimary, color: cls.borrowColor }}
        />
      </Grid>
    </Grid>
  );
}
